











import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { ReportDetails } from '@/models/reports/report-details';

@Component
export default class VideoPlayerModal extends Vue {
    @Prop({ required: true, type: Boolean }) public show: boolean;
    public showing: boolean = this.show;

    private videoId: string = 'UsJDOYIpR6c';
    private playerWidth: number = 854;
    private playerHeight: number = 480;

    private closeVideoPlayer() {
        this.$emit('close-video-player');
    }
}
